import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { Component, ElementRef, Input, OnInit, ViewChild, HostListener, AfterViewInit, Renderer2, ApplicationRef, Inject, Optional } from '@angular/core';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { FormBuilder, Validators } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { SharedService } from '../../../../shared/shared.service';
import * as moment from 'moment';
// import ResizeObserver from 'resize-observer-polyfill';

import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { DashboardService } from '../my-dashboard/my-dashboard.service';
import { ProgramPageService } from './program-page.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { useAnimation } from '@angular/animations';
import { slideInLeft, slideOutRight } from 'igniteui-angular';
import { SlideInOutAnimation } from '../../../../animations';
import { NgxSpinnerService } from 'ngx-spinner';
// import { A, B, C } from 'chart.js/dist/chunks/helpers.core';';
import { VgApiService } from '@videogular/ngx-videogular/core';
// import { VgMuteComponent, VgVolumeComponent } from 'ngx-videogular';
import { VgMuteComponent, VgVolumeComponent } from '@videogular/ngx-videogular/controls';
import { Options } from '@angular-slider/ngx-slider';
import { AnalyticsMainComponent } from '../../../analytics/components/analytics-main/analytics-main.component';
import { AnalyticsService } from 'src/app/modules/analytics/components/analytics/analytics.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomAlertComponent } from 'src/app/shared/modals/custom-alert/custom-alert.component';
import { LikesService } from 'src/app/shared/likes.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
export interface StepType {
	label: string;
	fields: FormlyFieldConfig[];
}

interface Language {
	language: string
}

const listAnimation = trigger('listAnimation', [
	transition('* <=> *', [
		query(':enter',
			[style({ opacity: 0 }), stagger('60ms', animate('600ms ease-out', style({ opacity: 1 })))],
			{ optional: true }
		),
		query(':leave',
			animate('200ms', style({ opacity: 0 })),
			{ optional: true }
		)
	])
]);

@Component({
	selector: 'app-program-page',
	templateUrl: './program-page.component.html',
	styleUrls: ['./program-page.component.scss'],
	providers: [
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { showError: true },
		},
	],
	animations: [listAnimation, SlideInOutAnimation]
	// animations: [SlideInOutAnimation]
})
export class ProgramPageComponent implements OnInit {
	@ViewChild('Iframe', { static: false }) Iframe!: ElementRef<HTMLIFrameElement>;
	@ViewChild('pdfViewer', { static: true }) pdfViewerRef!: ElementRef;
	// width: number = window.innerWidth;
	// @ViewChild('pdfEmbed') pdfEmbedRef!: ElementRef;
	// @ViewChild('embedprnt') embedprntRef!: ElementRef;
	showSideMenu: any = true;
	private snackbarSubscription: any;
	width: number = window.innerWidth;
	// @HostListener('document:click', ['$event'])
	// @ViewChild('myDiv') myDiv!: ElementRef;
	value: number = 0;
	options: Options = {
		floor: 0,
		ceil: 40
	};
	@ViewChild('myPlayer') myPlayer: any;
	public isCollapsed = false;
	animationState = 'out';
	videoPaused = true;
	isMuted = false;
	showBackButtonBlack = true;
	showVol = false;
	currentVideo = 0;
	public animationSettingsCustom = {
		closeAnimation: useAnimation(slideOutRight, {
			params: {
				duration: '100ms',
				toPosition: 'translateX(25px)'
			}
		}),
		openAnimation: useAnimation(slideInLeft, {
			params: {
				duration: '500s',
				fromPosition: 'translateX(-15px)',
				startOpacity: 0.1
			}
		})
	};

	showScreenOpenGif: boolean = false;
	showNewSectionGif: boolean = false;
	showCelebrationGif: boolean = false;
	showBlinkGif: boolean = false;

	languages: Language[] = [
		{ language: 'English' },
		{ language: 'Germany' },
		{ language: 'Turkey' },
	];

	activedStep = 0;
	model = {};

	firstFormGroup = this.formBuilder.group({
		firstCtrl: ['', Validators.required],
	});
	secondFormGroup = this.formBuilder.group({
		secondCtrl: ['', Validators.required],
	});
	mainData: any;
	expandedIndex = 0;
	public singleBranchExpand = true;
	// showBackButton: boolean = true;
	// showBackButtonBlack: boolean = true
	unitList: any;
	headerTitle: any = ' ';
	status: any = '“Be Curious... Not critical.”'
	programName: string = '';
	selectedSection: any = {};
	videoLocation: string = '';
	sectionDescription: string = '';
	sectionName: string = '';
	quizData: any = [];
	ispringQuizIframeUrl: string = '';
	ispringScormToken: string = '';
	ispringScormSectionIndex: number = 0;
	ispringScormUnitIndex: number = 0;
	ispringScormSubmitted: boolean = true;
	previousDays: any = [];
	upcomingDays: any = [];
	programStartDate: any;
	// todaysDfs: number = 0;
	sectionNo: string = '';
	selectedDateDfs: number = -1;
	currentDate: any;
	userProgress: any = {};
	parentSections: any = [];
	selectedTopicId: any;
	showQuizIconVar: boolean = false;
	daysInRow: number = 0;
	targetDfsLabels: any = [];
	months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	accordionActiveIds: any = [];
	setupInitialListener: boolean = false;
	blockLoader: string = 'blockLoader';
	previousVideoLocation: string | null = '';
	didShowSnackbar: boolean = false;
	didCompleteCourse: boolean = false;
	videoVolume: number = 0.6;
	muteButtonClicks: number = 0;
	progressId: any;
	userId: any;
	programId: any;
	activePrograms: any = [];
	progressSubscription: any;
	currentMonthAndYear: string = "";
	videoAutoSaveIntervalSeconds: number = 60;
	lastAutoSavedDurationByTopic: Record<string, number> = {};
	videoAutoSaveInFlightByTopic: Record<string, boolean> = {};
	// alertShown: boolean = false;
	@ViewChild('master') videoElemRef: ElementRef | undefined;
	isTranscript:boolean=false;
	isCommentBoxOpen:boolean=false;
	isVideoLiked:boolean=false;
	videolikesSubscription:Subscription | undefined;
	videoCommentsSubscription:Subscription | undefined;
	commentText:string="";
	videoComments: any = [];
	vttContent: any;
  	processedVttContent: any[] = [];
	@ViewChild('transcriptContent') transcriptContentRef: ElementRef | undefined;
	isVttFileUrl:boolean = false;
	programData: any;
	isPreview: boolean = false;
	dataForMenu: any;
	progressDetailsSubscription: Subscription | undefined;

	constructor(
		private router: Router,
		private spinner: NgxSpinnerService,
		private snackbar: MatSnackBar,
		private dashboardService: DashboardService,
		private sharedService: SharedService,
		private programService: ProgramPageService,
		private formBuilder: FormBuilder,
		private api: VgApiService,
		private elementRef: ElementRef,
		private appRef: ApplicationRef,
		private analyticsService: AnalyticsService,
		private dialogRef: MatDialog,
		private likesService: LikesService,
		private http: HttpClient,
    	@Optional() public programModalRef: MatDialogRef<ProgramPageComponent>
	) {
		// this.sharedService.activePrograms$.subscribe(activePrograms => {
		// 	this.activePrograms = activePrograms;
		// 	this.sortActiveProgramsByAccessOrder();
		// 	this.progressId = this.activePrograms[0].id;
		// 	[this.userId, this.programId] = this.progressId.split("_");
		// });

		localStorage.removeItem("alertShown");
		let previewState: any;
		const localStoragePreviewState = localStorage.getItem("previewState");
		if (localStoragePreviewState) {
			previewState = JSON.parse(localStoragePreviewState);
			localStorage.removeItem("previewState");
		}

		if (this.router.getCurrentNavigation()?.extras?.state) {
			const routerState = this.router.getCurrentNavigation()?.extras?.state ?? {};
			// this.sectionNo = routerState['sectionNo'];
			// this.getParentSections(this.sectionNo);
			this.progressId = routerState['progressId'] ? routerState['progressId'] : "";
			// console.log(this.progressId);
			if (this.progressId) {
				[this.userId, this.programId] = this.progressId.split("_");
			}
		} else if (previewState) {
			// console.log('got preview state', previewState);
			this.isPreview = previewState['isPreview'] ? previewState['isPreview'] : false;
			if (this.isPreview) {
				this.programData = previewState['programData'] ? previewState['programData'] : {};
				for (let section of this.programData.sections) {
					if (section.type === "menu") {
						for (let unit of section.menu) {
							if ((unit.type === "quiz" || unit.type === "Quiz") && (!unit.quizType || unit.quizType !== "ispring quiz")) {
								const quizTopic = unit.metadata?.topics?.find((topic: any) =>
									topic.interactions?.some((interaction: any) => interaction.question_group)
								);
								if (quizTopic) {
									const interaction = quizTopic.interactions.find((item: any) => item.question_group);
									unit.metadata.questions = JSON.parse(interaction.question_group);
								}
							}
						}
					}
				}

				this.dataForMenu = this.programData;
			}
		} else {
			this.router.navigate(['my-dashboard']);
		}

		if (this.sharedService.isLeapYear()) {
			this.months[1] = 29;
		}

		this.snackbarSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.snackbar.dismiss();
			}
		});

		this.currentDate = this.sharedService.getCurrentDate();
		this.currentMonthAndYear = this.sharedService.getCurrentMonthAndYear();

		this.progressSubscription = this.programService.progress$.subscribe(progress => {
			this.userProgress.progress = progress;

			// console.log('update prog', this.userProgress.progress);
			const progressId = this.userProgress.userId + "_" + this.userProgress.programId;
			if (this.userProgress.progress === 100) {
				document.body.scrollTop = 0;
				this.showGif('celebration');
				const progressLocalStorageVar = `completion_${progressId}`;
				const isUserInformed = localStorage.getItem(progressLocalStorageVar);

				if (!isUserInformed) {
					setTimeout(() => {
						this.openCustomAlert("completed");
						// this.snackbar.open("Woo Hoo! Congratulations on completing this Program!", "OK", {
						// 	duration: 3000
						// });
					}, 0);
					localStorage.setItem(progressLocalStorageVar, "true");
				}
			}
		});

		this.updateSideMenuVisibility();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		this.width = (<Window>event.target).innerWidth;
		this.updateSideMenuVisibility();
	}

	private updateSideMenuVisibility() {
		if (this.width < 1050) {
			this.showSideMenu = false;
		} else {
			this.showSideMenu = true;
		}
	}

	async ngAfterViewInit() {
		if (!this.isPreview) {
			this.showGif('screen-open');
			const muteBtn: any = document.querySelector('vg-mute');
			if (muteBtn) {
				muteBtn.isMuted = false;
			}
			const volumeBtn: any = document.querySelector('vg-volume');

			muteBtn?.addEventListener('click', () => {
				if (muteBtn.isMuted) {
					volumeBtn.classList.add('hidden');
				} else {
					volumeBtn.classList.remove('hidden');
				}
			});
			await this.setupVideoListeners();
		}
	}

	async ngOnInit() {
		window.addEventListener('message', this.handleIspringScormMessage);

		if (this.width < 1050) {
			this.showSideMenu = false
		}

		if (this.width > 1050) {
			this.showSideMenu = true
		}
		document.addEventListener('click', (event) => {
			const targetElement = event.target as HTMLElement;
			// Check if the click event target is inside the mat-slider element or its parent container
			if (!this.elementRef.nativeElement.contains(targetElement)) {
				this.showVol = false;
				// console.log('showVol', this.showVol)
			}

			// console.log(targetElement);
			if (targetElement && (targetElement.className === "cdk-overlay-backdrop custom-alert-backdrop-class" || targetElement.className === "custom-alert-container")) {
				this.dialogRef.closeAll();
			}
		});

		if (!this.isPreview) {
			await this.getUserProgress();
			this.programName = this.userProgress.name;
			const progressId = this.userProgress.userId + "_" + this.userProgress.programId;
			this.addSectionCollapses(this.userProgress.sections, false);
			// this.todaysDfs = this.getDfsForDate(moment(new Date()));
			this.selectedSection = this.getFirstPendingSection(this.userProgress.sections);
			await this.removeInvalidQuestions();

			if (this.userProgress.progress === 100) {
				const progressLocalStorageVar = `completion_${progressId}`;
				const isUserInformed = localStorage.getItem(progressLocalStorageVar);
				this.showGif('celebration');

				if (!isUserInformed) {
					// this.snackbar.open("Woo Hoo! Congratulations on completing this Program!", "OK", {
					// 	duration: 3000,
					// });
					this.openCustomAlert("completed");
					localStorage.setItem(progressLocalStorageVar, "true");
				}
				this.selectedSection = this.getFirstContentSection(this.userProgress.sections);
			}

			this.afterSectionSelected();
			this.daysInRow = this.getDaysInRow(this.userProgress.daysInRow);
			await this.setTargetDfsLabels(false);
			this.programData = await this.programService.getProgramData(this.programId);

			const orgData = await this.programService.checkProgramExistenceAndProgressBarLock();
			const ProgressBarLock: any = orgData?.progressBarLock

			if (!ProgressBarLock) {
				// console.log('ProgressBarLock', ProgressBarLock)
				const scrubBarElement = document.getElementById('scrub-bar');
				scrubBarElement?.classList.add("clickable");
				scrubBarElement?.classList.remove("non-clickable");
			}
			// this.muteVideoInitially();

			const idsObject = {
				programId: this.programId,
				sectionId: this.selectedSection.sno,
				topicId: this.selectedTopicId,
				userId: this.userId
			};

			this.videolikesSubscription = this.likesService.checkIsVideoLiked(idsObject)?.subscribe(data =>{
				if(data && data.length > 0) {
					this.isVideoLiked = true;
				}else {
					this.isVideoLiked = false;
				}
			})
			this.getVideoComments();
		} else {
			this.addSectionCollapses(this.programData.sections, false);
			this.selectedSection = this.getFirstPendingSection(this.programData.sections);
			this.afterSectionSelected();
		}

		if (this.programId && this.userId && this.selectedSection?.quizType === 'ispring quiz') {
			this.getProgressDetails();
		}
	}

	async removeInvalidQuestions() {
		try {
			// console.log("selectedSection:", this.selectedSection);
			if (
				this.selectedSection?.type === "quiz" &&
				(!this.selectedSection.quizType || this.selectedSection.quizType !== "ispring quiz") &&
				this.selectedSection.metadata?.questions?.length
			) {
				const questionsArray: any[] = this.selectedSection.metadata.questions;
				if (Array.isArray(questionsArray)) {
					let matchIndex = questionsArray.findIndex(el => el.text == '');

					while (matchIndex !== -1) {
						questionsArray.splice(matchIndex, 1);
						matchIndex = questionsArray.findIndex(el => el.text == '');
					}
				}
			}
		} catch (e) {
			// console.log("removeInvalidQuestions error:", e);
		}
	}

	prevStep(step: any) {
		// console.log('step, ', step);
		this.activedStep = step - 1;
	}

	nextStep(step: any) {
		this.activedStep = step + 1;
	}

	clickedSection(section: any) {
		if (this.isPreview) {
			this.selectedSection = section;
			this.afterSectionSelected();
		} else {
			var prevSectionDfs = Number(section.dfs) - 1;
			var isPrevDfsCompleted = false;

			if (prevSectionDfs >= 1) {
				isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
			} else {
				isPrevDfsCompleted = true;
			}

			if (!isPrevDfsCompleted) {
				if (localStorage.getItem("alertShown") !== "true") {
					if (this.selectedSection.type === "quiz") {
						this.openCustomAlert("quiz");
					} else if (this.selectedSection.type === "download") {
						this.openCustomAlert("download");
					} else if (this.selectedSection.type === "video") {
						// console.log("1");
						this.openCustomAlert("video");
					}
					localStorage.setItem("alertShown", "true");
				}
				return;
			}
			this.selectedSection = section;
			this.afterSectionSelected();
		}
	}

	getFirstContentSection(sections: any): any {
		for (let section of sections) {
			if (section.type === 'menu' || section.type === 'Menu') {
				return this.getFirstContentSection(section.menu);
			} else if (section.type === 'video' || section.type === 'quiz' || section.type === 'Video' || section.type === 'Quiz' || section.type === 'download' || section.type === 'Download') {
				return section;
			}
		}
	}

	getFirstPendingSection(sections: any): any {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const firstPendingSection = this.getFirstPendingSection(section.menu);

					if (firstPendingSection && Object.keys(firstPendingSection).length >= 1) {
						return firstPendingSection;
					} else {
						continue;
					}
				} else if (!section.progress || section.progress !== 100) {
					return section;
				}
			}
		}
	}

	async clickedVideoTopic(section: any, topic: any) {
		if (this.isPreview) {
			this.selectedSection = section;
			this.updateVideoElement(topic.videoLocation);
			this.sectionDescription = topic.description;
			this.sectionName = topic.name;
			this.selectedTopicId = topic.id;
			this.playVideo();
		} else {
			var prevSectionDfs = Number(section.dfs) - 1;
			var isPrevDfsCompleted = false;

			if (prevSectionDfs >= 1) {
				isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
			} else {
				isPrevDfsCompleted = true;
			}

			if (!isPrevDfsCompleted) {
				if (localStorage.getItem("alertShown") !== "true") {
					if (this.selectedSection.type === "quiz") {
						this.openCustomAlert("quiz");
					} else if (this.selectedSection.type === "download") {
						this.openCustomAlert("download");
					} else if (this.selectedSection.type === "video") {
						// console.log("1");
						this.openCustomAlert("video");
					}
					localStorage.setItem("alertShown", "true");
				}
				return;
			}

			this.selectedSection = section;
			this.updateVideoElement(topic.videoLocation);
			this.sectionDescription = topic.description;
			this.sectionName = topic.name;
			this.selectedTopicId = topic.id;
			this.showGif('new-section');
			await this.setupVideoListeners();
			this.playVideo();
		}
	}

	clickedVideoTopicInChild(obj: any) {
		if (this.isPreview) {
			this.selectedSection = obj.section;
			this.updateVideoElement(obj.topic.videoLocation);
			this.sectionDescription = obj.topic.description;
			this.sectionName = obj.topic.name;
			this.selectedTopicId = obj.topic.id;
			this.playVideo();
		} else {
			var prevSectionDfs = Number(obj.section.dfs) - 1;
			var isPrevDfsCompleted = false;

			if (prevSectionDfs >= 1) {
				isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
			} else {
				isPrevDfsCompleted = true;
			}

			if (!isPrevDfsCompleted) {
				if (localStorage.getItem("alertShown") !== "true") {
					if (this.selectedSection.type === "quiz") {
						this.openCustomAlert("quiz");
					} else if (this.selectedSection.type === "download") {
						this.openCustomAlert("download");
					} else if (this.selectedSection.type === "video") {
						// console.log("1");
						this.openCustomAlert("video");
					}
					localStorage.setItem("alertShown", "true");
				}
				return;
			}

			this.selectedSection = obj.section;
			this.updateVideoElement(obj.topic.videoLocation);
			this.sectionDescription = obj.topic.description;
			this.sectionName = obj.topic.name;
			this.selectedTopicId = obj.topic.id;
			this.showGif('new-section');
			this.setupVideoListeners();
			this.playVideo();
			if (this.width < 1050) {
				this.showSideMenu = false
			}
		}
	}

	getParentSection(topicId: string, sections: any): any {
		for (let section of sections) {
			if (section.type === 'video' || section.type === 'Video') {
				for (let topic of section.metadata.topics) {
					if (topic.id === topicId) {
						return section;
					}
				}
			} else if (section.type === 'menu' || section.type === 'Menu') {
				const newSection = this.getParentSection(topicId, section.menu);

				if (newSection !== -1) {
					return newSection;
				} else {
					continue;
				}
			}
		}

		return -1;
	}

	updateVideoElement(location: string) {
		const videoElement = document.getElementById('masterVideo');

		if (videoElement) {
			// console.log(videoElement);
			videoElement.innerHTML = `<source src="${location}" type="video/mp4" id="videoSource"></source>`;
			// console.log('updated video element');
		} else {
			setTimeout(() => {
				this.updateVideoElement(location);
			}, 500);
		}
	}

	selectOption(event: any, optionIndex: number, index: number) {
		if (event.checked) {
			this.quizData[index].push(optionIndex);
		} else {
			this.quizData[index] = this.quizData[index].filter((item: any) => item !== optionIndex);
		}
	}

	selectRadioOption(event: any, index: number, type: string) {
		if (!type || type === "1") {
			this.quizData[index] = event.value + 1;
		} else if (type === "2") {
			this.quizData[index] = event.value;
		}
	}

	shouldSubmitBeDisabled() {
		if (this.isPreview) {
			return false;
		} else {
			for (let answer of this.quizData) {
				// console.log('quizData', this.quizData)
				if ((typeof answer === 'number' && answer === -1) || (typeof answer === 'object' && answer.length === 0)) {
					return true;
				}
			}

			return false;
		}
	}

	async submitQuiz() {
		this.snackbar.open("Submitting quiz...");
		this.getQuizResult();

		let quizResult: string = '';
		if (this.selectedSection.metadata.totalCorrect === this.selectedSection.metadata.questions.length) {
			quizResult = 'Woo Hoo! Congratulations, all your answers are correct';
		} else {
			let numValidQuestions = 0;
			for (let question of this.selectedSection.metadata.questions) {
				if (question.text) {
					numValidQuestions += 1;
				}
			}
			quizResult = `${this.selectedSection.metadata.totalCorrect} / ${numValidQuestions} correct answers. Score: ${Math.ceil(this.selectedSection.earnedPts)}`;
		}
		this.snackbar.open(quizResult, "OK", {
			duration: 3000
		});

		if (!this.isPreview) {
			await this.spinner.show("blockLoader");
			await this.programService.saveDataConditional(this.progressId, this.userProgress, true, false);
			await this.spinner.hide("blockLoader");
			await this.setTargetDfsLabels(true);
		}
	}

	getDfsForDate(date: any) {
		const daysSinceProgramStarted = date.diff(this.programStartDate, "days");
		return daysSinceProgramStarted + 1;
	}

	async getUserProgress() {
		this.userProgress = await this.dashboardService.getUserProgress(this.userId, this.programId);
		this.dataForMenu = this.userProgress;
		if (!Number.isFinite(Number(this.userProgress?.progress))) {
			this.userProgress.progress = this.programService.getOverallProgress(this.userProgress.sections);
		}
		// console.log(this.userProgress);
		if (this.userProgress.progress === 100) {
			this.didCompleteCourse = true;
		}
	}

	addSectionCollapses(sections: any, condition: boolean) {
		if (sections?.length >= 1) {
			for (let section of sections) {
				section.collapsed = condition;

				if (section.type === 'menu' || section.type === 'Menu') {
					this.addSectionCollapses(section.menu, condition);
				}
			}
		}
	}

	collapseItemsBySection(sections: any) {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section?.sno !== this.selectedSection?.sno && !this.parentSections.includes(section?.sno)) {
					section.collapsed = true;
				} else {
					section.collapsed = false;
				}

				if (section.type === 'menu' || section.type === 'Menu') {
					this.collapseItemsBySection(section.menu);
				}
			}
		}
	}

	getParentSections(sectionNo: string) {
		this.parentSections = [];

		while (sectionNo.includes(".")) {
			const lastIndexOf = sectionNo.lastIndexOf(".");
			sectionNo = sectionNo.slice(0, lastIndexOf);
			this.parentSections.unshift(sectionNo);
		}
	}

	getSectionByNo(sectionNo: string, sections: any): any {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const foundSection = this.getSectionByNo(sectionNo, section.menu);

					if (foundSection && Object.keys(foundSection).length >= 1) {
						return foundSection;
					} else {
						continue;
					}
				}

				if (section.type === 'video' || section.type === 'quiz' || section.type === 'download' || section.type === 'Video' || section.type === 'Quiz' || section.type === 'Download') {
					if (section.sno === sectionNo) {
						return section;
					}
				}
			}
		}
	}

	getSectionByNoProgress(sectionNo: string, sections: any): any {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const foundSection = this.getSectionByNoProgress(sectionNo, section.menu);

					if (foundSection && Object.keys(foundSection).length >= 1) {
						return foundSection;
					} else {
						continue;
					}
				}

				if (section.type === 'video' || section.type === 'quiz' || section.type === 'download' || section.type === 'Video' || section.type === 'Quiz' || section.type === 'Download') {
					if (section.sno === sectionNo) {
						return section;
					}
				}
			}
		}
	}

	afterSectionSelected() {
		this.collapseByActiveSection();
		// console.log('selectedSection', this.selectedSection)
		if (this.selectedSection?.type === 'video' || this.selectedSection?.type === 'Video') {
			let firstTopic;

			if (this.isPreview || this.userProgress.progress === 100) {
				firstTopic = this.selectedSection.metadata.topics[0];
			} else {
				let firstPendingSection = this.getSectionByNoProgress(this.selectedSection.sno, this.userProgress.sections);
				// console.log(firstPendingSection);

				if (firstPendingSection.progress === 100) {
					firstTopic = firstPendingSection.metadata.topics[0];
				} else {
					for (let topic of firstPendingSection.metadata.topics) {
						if (topic.progress !== 100) {
							firstTopic = topic;
							break;
						}
					}
				}
			}

			this.videoLocation = firstTopic.videoLocation;
			this.sectionDescription = firstTopic.description;
			this.sectionName = firstTopic.name;
			this.selectedTopicId = firstTopic.id;

			if (!this.isPreview) {
				if (!this.setupInitialListener) {
					this.setupInitialListener = true;

					setTimeout(() => {
						this.setupVideoListeners();
					}, 0);
				} else {
					this.setupVideoListeners();
				}
			}
		} else if (
			(this.selectedSection.type === 'quiz' || this.selectedSection.type === 'Quiz') &&
			(!this.selectedSection.quizType || this.selectedSection.quizType !== "ispring quiz")
		) {
			this.quizData = [];
			for (let question of this.selectedSection.metadata.questions) {
				if (!question.type || question.type === "1" || question.type === "2") {
					this.quizData.push(-1);
				} else if (question.type === '3') {
					this.quizData.push([]);
				}
			}
		} else if (
			(this.selectedSection.type === 'quiz' || this.selectedSection.type === 'Quiz') &&
			this.selectedSection.quizType === "ispring quiz"
		) {
			this.loadIspringQuizIframeUrl();
		}
	}

	async loadIspringQuizIframeUrl() {
		this.ispringQuizIframeUrl = '';
		this.ispringScormSubmitted = true; // ignore messages until a new token is ready below
		const section = this.selectedSection;
		const sectionIndex = section.quizSectionIndex;
		const unitIndex = section.quizUnitIndex;

		if (sectionIndex === undefined || sectionIndex === null || unitIndex === undefined || unitIndex === null) {
			console.log("iSpring quiz unit is missing section/unit index metadata; redeploy required.");
			return;
		}

		try {
			const token = await this.programService.generateIspringQuizToken(this.progressId, sectionIndex, unitIndex);

			if (section === this.selectedSection && token) {
				this.ispringScormSectionIndex = sectionIndex;
				this.ispringScormUnitIndex = unitIndex;
				this.ispringScormToken = token;
				this.ispringScormSubmitted = false;
				this.ispringQuizIframeUrl = `${section.quizUrl}?Name=Test&userId=${this.userId}&PROGRESS_ID=${this.progressId}&SECTION_INDEX=${sectionIndex}&UNIT_INDEX=${unitIndex}&TOKEN=${token}`;
			}
		} catch (err) {
			console.log("Unable to generate iSpring quiz token", err);
		}
	}

	/**
	 * The deployed quiz's own origin (e.g. the iSpring hosting target) differs from
	 * this app's origin, so a SCORM `window.API`/`window.API_1484_11` object exposed
	 * here could never be reached by the quiz iframe - browsers block cross-origin
	 * access to arbitrary window properties. Instead, `extractAndProcessQuizZip`
	 * injects a same-origin SCORM bridge script into the deployed quiz that relays
	 * the final score here via `postMessage`, which is cross-origin-safe. This
	 * listener receives that message and forwards it to `getIspringQuizResults`
	 * using the one-time token minted for the current iframe URL.
	 */
	handleIspringScormMessage = (event: MessageEvent) => {
		if (!event.data || event.data.source === 'ignite-ispring-scorm-bridge-debug') {
			if (event.data) {
				console.log('[iSpring SCORM debug]', event.data.call, event.data.args);
			}
			return;
		}

		if (!event.data || event.data.source !== 'ignite-ispring-scorm-bridge') {
			return;
		}

		if (this.ispringScormSubmitted || !this.ispringScormToken) {
			return;
		}

		this.ispringScormSubmitted = true;
		this.submitIspringScormResult(this.ispringScormSectionIndex, this.ispringScormUnitIndex, this.ispringScormToken, Number(event.data.sp), Number(event.data.tp));
	};

	submitIspringScormResult(sectionIndex: number, unitIndex: number, token: string, sp: number, tp: number) {
		const url = `https://us-central1-${environment.firebase.projectId}.cloudfunctions.net/program-getIspringQuizResults`;

		this.http.post(url, {
			PROGRESS_ID: this.progressId,
			SECTION_INDEX: sectionIndex,
			UNIT_INDEX: unitIndex,
			TOKEN: token,
			sp,
			tp
		}).subscribe({
			next: async () => {
				this.userProgress = await this.dashboardService.getUserProgress(this.userId, this.programId);
			},
			error: (err) => console.log("Unable to submit iSpring SCORM result", err)
		});
	}

	getQuizResult() {
		let questions = this.selectedSection.metadata.questions;
		let totalCorrect = 0;
		let userProgressSectionReference, userProgressMetadata;
		if (this.isPreview) {
			userProgressSectionReference = this.getSectionByNo(this.selectedSection.sno, this.programData.sections);
		} else {
			userProgressSectionReference = this.getSectionByNo(this.selectedSection.sno, this.userProgress.sections);
		}
		userProgressMetadata = userProgressSectionReference.metadata;
		let numValidQuestions = 0;

		for (let i = 0; i < questions.length; i += 1) {
			let question = questions[i];
			if (question.text) {
				numValidQuestions += 1;
			}
			// console.log(this.quizData[i]);

			if (question.type === '3') {
				question.attemptedAnswer = this.quizData[i].join(",");
				userProgressMetadata.questions[i].attemptedAnswer = this.quizData[i].join(",");
			} else {
				if (question.type === '2') {
					question.attemptedAnswer = String(Number(this.quizData[i]) + 1);
					userProgressMetadata.questions[i].attemptedAnswer = String(Number(this.quizData[i]) + 1);
				} else {
					question.attemptedAnswer = String(this.quizData[i]);
					userProgressMetadata.questions[i].attemptedAnswer = String(this.quizData[i]);
				}
			}

			// console.log('correct', question.correct_answer);
			// console.log('attempted', question.attemptedAnswer);
			if (question.type === '3') {
				let correctAnswer = question.correct_answer?.split(",");
				let correctModified = [];

				for (let j = 0; j < correctAnswer.length; j += 1) {
					let answer = correctAnswer[j];

					if (answer) {
						correctModified.push(answer);
					}
				}

				// console.log('correct', correctModified);

				let attemptedAnswers = question.attemptedAnswer?.split(",");
				attemptedAnswers.sort((a: any, b: any) => {
					let numA = Number(a);
					let numB = Number(b);

					if (numA < numB) {
						return -1;
					} else if (numA > numB) {
						return 1;
					}

					return 0;
				});

				// console.log('attempted', attemptedAnswers);
				let isQuestionCorrect = true;

				for (let j = 0; j < correctModified.length; j += 1) {
					if (correctAnswer[j] !== attemptedAnswers[j]) {
						question.isCorrect = false;
						userProgressMetadata.questions[i].isCorrect = false;

						isQuestionCorrect = false;
						break;
					}
				}

				if (isQuestionCorrect) {
					totalCorrect += 1;
					question.isCorrect = true;
					userProgressMetadata.questions[i].isCorrect = true;
				}
			} else {
				if (question.attemptedAnswer === question.correct_answer) {
					// console.log('is correct');
					totalCorrect += 1;
					question.isCorrect = true;

					userProgressMetadata.questions[i].isCorrect = true;
				} else {
					// console.log('nope');
					question.isCorrect = false;
					userProgressMetadata.questions[i].isCorrect = false;
				}
			}
		}

		// console.log('totalCorrect', totalCorrect);
		if (!this.isPreview) {
			this.resetQuizData();
		}

		this.selectedSection.metadata.totalCorrect = totalCorrect;
		this.selectedSection.metadata.attempted = true;
		const ptsPerQuestion = this.selectedSection.pts / numValidQuestions;
		const earnedPts = totalCorrect * ptsPerQuestion;
		this.selectedSection.earnedPts = earnedPts;
		const quizProgress = Math.floor((this.selectedSection.earnedPts * 100) / this.selectedSection.pts);
		this.selectedSection.answerProgress = quizProgress;
		this.selectedSection.progress = 100;
		this.selectedSection.completed = true;

		userProgressMetadata.totalCorrect = totalCorrect;
		userProgressMetadata.attempted = true;
		userProgressSectionReference.earnedPts = this.selectedSection.earnedPts;
		userProgressSectionReference.answerProgress = quizProgress;
		userProgressSectionReference.progress = 100;
		userProgressSectionReference.completed = true;
	}

	getProgressForDfs(dateDfs: number, sections: any) {
		let progress = 0;
		let totalProgress = 0;

		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					let [menuprogress, menuTotalProgress] = this.getProgressForDfs(dateDfs, section.menu);
					progress += menuprogress;
					totalProgress += menuTotalProgress;
				} else if (section.dfs === dateDfs && (section.type === 'video' || section.type === 'quiz' || section.type === 'download' || section.type === 'Video' || section.type === 'Quiz' || section.type === 'Download')) {
					progress += section.progress;
					totalProgress += 100;
				}
			}
		}

		return [progress, totalProgress];
	}

	isSectionCompleted(sectionNo: number, sections: any): boolean {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					if (section.menu.length >= 1) {
						const isSectionComplete = this.isSectionCompleted(sectionNo, section.menu);

						if (isSectionComplete) {
							return true;
						} else {
							continue;
						}
					}
				} else if ((section.type === 'video' || section.type === 'quiz' || section.type === 'Video' || section.type === 'Quiz') && section.sno === sectionNo) {
					if (section.progress === 100) {
						return true;
					}
				}
			}
		}

		return false;
	}

	async videoPlayEvent(videoElement: any, selectedTopicId: any, selectedSection: any, userProgress: any) {
		let watchedDuration = Math.ceil(videoElement.currentTime);

		if (this.isProgramPlayerRoute()) {
			if (this.isVideoPlaying(videoElement)) {
				setTimeout(async () => {
					await this.videoPlayEvent(videoElement, selectedTopicId, selectedSection, userProgress);
				}, 2000);
			}

			if (this.getTopicProgress(selectedTopicId, userProgress.sections) < 100) {
				if (this.isVideoPlaying(videoElement)) {
					this.updateVideoProgress(watchedDuration, selectedTopicId, selectedSection, userProgress, videoElement.duration);
					await this.autoSaveVideoProgress(selectedTopicId, userProgress, watchedDuration);
				} else if (videoElement.paused) {
					this.updateVideoProgress(watchedDuration, selectedTopicId, selectedSection, userProgress, videoElement.duration);
					if (userProgress.progress < 100) {
						await this.programService.saveDataConditional(this.progressId, userProgress, false, true, watchedDuration);
						this.markVideoProgressSaved(selectedTopicId, watchedDuration);
					}
				}

				await this.setTargetDfsLabels(false);
			} else {
				if (Math.floor(Number(watchedDuration)) >= Math.floor(Number(videoElement.duration))) {
					const isMovingAhead = localStorage.getItem('isMovingAhead');
					if (isMovingAhead === "true") {} else {
						this.updateVideoProgress(watchedDuration, selectedTopicId, selectedSection, userProgress, videoElement.duration);
						if (userProgress.progress < 100) {
							await this.programService.saveDataConditional(this.progressId, userProgress, false, true, watchedDuration);
							this.markVideoProgressSaved(selectedTopicId, watchedDuration);
						}
						await this.setTargetDfsLabels(true);
						// console.log("did set dfs label");
						localStorage.setItem("isMovingAhead", "true");
						await this.moveToNextSection();
						// this.toggleIsTranscript();
						setTimeout(() => {
							localStorage.removeItem("isMovingAhead");
						}, 10000);
					}
				}
			}
		}
	}

	isProgramPlayerRoute() {
		const normalizedRoute = this.router.url.split("?")[0].replace(/\/+$/, "");
		return normalizedRoute === "/programs";
	}

	markVideoProgressSaved(topicId: any, watchedDuration: number) {
		const topicKey = String(topicId || "");
		const normalizedDuration = Number(watchedDuration);

		if (!topicKey || !Number.isFinite(normalizedDuration) || normalizedDuration < 0) {
			return;
		}

		const previousDuration = Number(this.lastAutoSavedDurationByTopic[topicKey] || 0);
		this.lastAutoSavedDurationByTopic[topicKey] = Math.max(previousDuration, normalizedDuration);
	}

	async autoSaveVideoProgress(topicId: any, userProgress: any, watchedDuration: number) {
		const topicKey = String(topicId || "");
		const normalizedDuration = Number(watchedDuration);

		if (!topicKey || !Number.isFinite(normalizedDuration) || normalizedDuration < this.videoAutoSaveIntervalSeconds) {
			return;
		}

		if (userProgress.progress >= 100 || this.videoAutoSaveInFlightByTopic[topicKey]) {
			return;
		}

		const lastSavedDuration = Number(this.lastAutoSavedDurationByTopic[topicKey] || 0);
		if ((normalizedDuration - lastSavedDuration) < this.videoAutoSaveIntervalSeconds) {
			return;
		}

		this.videoAutoSaveInFlightByTopic[topicKey] = true;

		try {
			await this.programService.saveDataConditional(this.progressId, userProgress, false, false, normalizedDuration);
			this.markVideoProgressSaved(topicId, normalizedDuration);
		} finally {
			this.videoAutoSaveInFlightByTopic[topicKey] = false;
		}
	}

	updateVideoProgress(watchedDuration: any, selectedTopicId: any, selectedSection: any, userProgress: any, uploadedVideoDuration: any) {
		// console.log(watchedDuration);
		let topics = selectedSection.metadata.topics;
		let userProgressSectionReference, userProgressMetadata;
		let allTopicsLearningDuration = 0;

		const topicIndex = topics.findIndex((topic: any) => topic.id === selectedTopicId);
		topics[topicIndex].learningDuration = Number(watchedDuration);

		if (Number(topics[topicIndex].videoDuration) - topics[topicIndex].learningDuration <= 2) {
			topics[topicIndex].learningDuration = Number(topics[topicIndex].videoDuration);
		}

		const topicDuration = Number(topics[topicIndex].videoDuration);
		const uploadedDuration = Number(uploadedVideoDuration);
		const resolvedTopicDuration = Number.isFinite(topicDuration) && topicDuration > 0
			? topicDuration
			: (Number.isFinite(uploadedDuration) && uploadedDuration > 0 ? uploadedDuration : 0);

		if (resolvedTopicDuration > 0 && (!Number.isFinite(topicDuration) || topicDuration <= 0)) {
			topics[topicIndex].videoDuration = resolvedTopicDuration;
		}

		const topicProgress = resolvedTopicDuration > 0
			? Math.floor((topics[topicIndex].learningDuration * 100) / resolvedTopicDuration)
			: 0;
		topics[topicIndex].progress = topicProgress;

		userProgressSectionReference = this.getSectionByNo(selectedSection.sno, userProgress.sections);
		userProgressMetadata = userProgressSectionReference.metadata;

		for (let topic of userProgressMetadata.topics) {
			const learningDuration = Number(topic.learningDuration);
			if (Number.isFinite(learningDuration) && learningDuration > 0) {
				allTopicsLearningDuration += learningDuration;
			}
		}

		userProgressMetadata.learningDuration = allTopicsLearningDuration;

		let totalVideoDuration = 0;
		if (Number.isFinite(Number(selectedSection.metadata.videoDuration)) && Number(selectedSection.metadata.videoDuration) > 0) {
			totalVideoDuration = Number(selectedSection.metadata.videoDuration);
		} else {
			for (let topic of topics) {
				const duration = Number(topic.videoDuration);
				if (Number.isFinite(duration) && duration > 0) {
					totalVideoDuration += duration;
				}
			}
		}

		const sectionProgress = totalVideoDuration > 0
			? Math.floor((allTopicsLearningDuration * 100) / totalVideoDuration)
			: 0;
		selectedSection.progress = sectionProgress;

		if (resolvedTopicDuration > 0 && resolvedTopicDuration - topics[topicIndex].learningDuration <= 2) {
			userProgressMetadata.topics[topicIndex].learningDuration = resolvedTopicDuration;
			userProgressMetadata.topics[topicIndex].progress = 100;
		} else {
			userProgressMetadata.topics[topicIndex].learningDuration = watchedDuration;
			userProgressMetadata.topics[topicIndex].progress = topicProgress;
		}

		userProgressSectionReference.progress = sectionProgress;

		let allTopicsProgress = 0;
		for (let topic of userProgressMetadata.topics) {
			const progress = Number(topic.progress);
			allTopicsProgress += Number.isFinite(progress) ? progress : 0;
		}
		if ((allTopicsProgress / userProgressMetadata.topics.length) === 100) {
			userProgressMetadata.learningDuration = Number(userProgressMetadata.videoDuration);
			userProgressSectionReference.progress = 100;
		}
	}

	isVideoPlaying(video: any) {
		return !!(!video.paused && !video.ended && video.readyState > 2);
	}

	async setupVideoListeners() {
		const videoElement: any = document.getElementById('masterVideo');

		// console.log(this.isUserAdmin());
		// console.log('videoElement', videoElement)
		const orgId = localStorage.getItem("orgId") ?? "";
		const orgData: any = await this.analyticsService.getOrgData(orgId);
		let progressBarLock;
		if (orgData) {
			progressBarLock = orgData.progressBarLock;
		}

		if (videoElement) {
			// console.log('setup video listener');
			const viewingDuration = this.getTopicLearningDuration(this.selectedTopicId, this.userProgress.sections);
			const scrubBarElement = document.getElementById('scrub-bar');
			if (Number.isFinite(Number(viewingDuration)) && Number(viewingDuration) >= 0) {
				this.markVideoProgressSaved(this.selectedTopicId, Number(viewingDuration));
			}

			if (!this.isUserAdmin()) {
				// console.log('not an admin - disable');
				if (progressBarLock) {
					scrubBarElement?.classList.remove("clickable");
					scrubBarElement?.classList.add("non-clickable");
				}
			}

			if (viewingDuration >= 1) {
				const videoDuration = this.getTopicTotalDuration(this.selectedTopicId, this.userProgress.sections);
				const currentTime = videoElement.currentTime;

				if (isNaN(videoDuration) || isNaN(currentTime)) {
					// scrubBarElement?.classList.remove("clickable");
					// scrubBarElement?.classList.add("non-clickable");
					setTimeout(async () => {
						await this.setupVideoListeners();
					}, 500);
					return;
				} else {
					if (videoDuration - viewingDuration <= 3) {
						if (!this.isUserAdmin()) {
							// console.log('not an admin - enable');
							scrubBarElement?.classList.remove("non-clickable");
							scrubBarElement?.classList.add("clickable");
						}
					} else {
						if (videoDuration - viewingDuration >= 5) {
							videoElement.currentTime = viewingDuration;

						if (!this.isUserAdmin()) {
							// console.log('not an admin - disable');
							if (progressBarLock) {
								scrubBarElement?.classList.remove("clickable");
								scrubBarElement?.classList.add("non-clickable");
							}
						}
						} else {
							if (!this.isUserAdmin()) {
							// console.log('not an admin - enable');
								scrubBarElement?.classList.remove("non-clickable");
								scrubBarElement?.classList.add("clickable");
							}
						}
					}
				}
			} else {
				if (!this.isUserAdmin()) {
					// console.log('not an admin - disable');
					if (progressBarLock) {
						scrubBarElement?.classList.remove("clickable");
						scrubBarElement?.classList.add("non-clickable");
					}
				}
			}

			videoElement.onplaying = async (event: any) => {
				// console.log('on play event');
				this.showGif("new-section");
				await this.videoPlayEvent(videoElement, this.selectedTopicId, this.selectedSection, this.userProgress);
			};
		} else {
			setTimeout(async () => {
				await this.setupVideoListeners();
			}, 500);
		}
	}

	getTaskStatus(sectionNo: any, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.sno === sectionNo) {
					if (section.progress === 0) {
						return { code: 1, status: 'task_not_attempted_line' };
					} else if (section.progress > 0 && section.progress < 100) {
						return { code: 1, status: 'task_partially_completed_line' };
					} else if (section.progress === 100) {
						return { code: 1, status: 'task_completed_line' };
					}
				}

				if (section.type === 'menu' || section.type === 'Menu') {
					const statusAndCode = this.getTaskStatus(sectionNo, section.menu);

					if (statusAndCode.code === 1) {
						return statusAndCode;
					} else {
						continue;
					}
				}
			}
		}

		return { code: 0, status: 'task_not_attempted_line' };
	}

	getTopicStatus(sectionNo: any, topicId: any, sections: any): any {
		if (sections && sections.length >= 1) {

			// if (topicId == this.selectedTopicId){
			// 	return 'target_green'
			// }

			for (let section of sections) {
				if (section.sno === sectionNo) {

					for (let topic of section.metadata.topics) {
						if (topic.id === topicId) {
							if (topic.progress === 0) {
								return 'task_not_attempted_line';
							} else if (topic.progress > 0 && topic.progress < 100) {
								return 'task_partially_completed_line';
							} else if (topic.progress === 100) {
								return 'task_completed_line';
							}
						}
					}
				}

				if (section.type === 'menu' || section.type === 'Menu') {
					return this.getTopicStatus(sectionNo, topicId, section.menu);
				}
			}
		}

		return 'task_not_attempted_line';
	}

	async playVideo() {
		const videoElement: any = document.getElementById('masterVideo');
		if (this.userProgress.progress === 100) {
			await this.dashboardService.updateProgramLastAccess(this.progressId);
		}

		if (videoElement) {
			setTimeout(() => {
				videoElement.play();
			}, 500);
		}
	}

	// toggleShowDiv(divName: string) {
	// 	if (divName === 'divA') {
	// 		console.log(this.animationState);
	// 		this.animationState = this.animationState === 'out' ? 'in' : 'out';
	// 		console.log(this.animationState);
	// 	}
	// }

	getQuizScore(sectionNo: any, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const quizScore = this.getQuizScore(sectionNo, section.menu);

					if (quizScore !== -1) {
						return quizScore;
					} else {
						continue;
					}
				} else if (section.sno === sectionNo) {
					return `${section.metadata.totalCorrect} / ${section.metadata.questions.length}`;
				}
			}
		}

		return -1;
	}

	restartQuizButton(sections: any) {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					this.restartQuizButton(section.menu);
				} else if (section.sno === this.selectedSection.sno) {
					section.progress = 0;
				}
			}
		}
	}

	getNextSectionName() {
		if (this.selectedSection.type === "video" || this.selectedSection.type === "Video") {
			let nextTopic;
			if (this.isPreview) {
				nextTopic = this.getSectionNextTopic(this.selectedTopicId, this.programData.sections);
			} else {
				nextTopic = this.getSectionNextTopic(this.selectedTopicId, this.userProgress.sections);
			}
			// console.log(nextTopic);

			if (nextTopic && Object.keys(nextTopic).length >= 1) {
				return nextTopic.name;
			}

			const splitBySno = this.selectedSection?.sno?.split(".");
			let i = splitBySno.length;
			let sectionCheck = false;
			// console.log(splitBySno);

			for (let j = i - 1; j >= 0; j -= 1) {
				let newNum = Number(splitBySno[j]) + 1;

				let sectionNoToCheck;
				if (j === 0) {
					sectionNoToCheck = newNum + "." + "1";
				} else {
					sectionNoToCheck = splitBySno.slice(0, j).join(".") + "." + newNum;
				}
				// console.log(sectionNoToCheck);

				let nextSection;
				if (this.isPreview) {
					nextSection = this.getSectionByNo(sectionNoToCheck, this.programData.sections);
				} else {
					nextSection = this.getSectionByNo(sectionNoToCheck, this.userProgress.sections);
				}
				if (nextSection && Object.keys(nextSection).length === 0 && !sectionCheck) {
					sectionCheck = true;
					continue;
				}
				// console.log(nextSection);

				if (nextSection) {
					if (nextSection.type === "quiz" || nextSection.type === "download" || nextSection.type === "Quiz" || nextSection.type === "Download") {
						return nextSection.name;
					} else {
						return nextSection.metadata.topics[0].name;
					}
				}
			}
		}

		// console.log('Current Section no', this.selectedSection.sno);
		const splitBySno = this.selectedSection?.sno ? this.selectedSection.sno?.split(".") : [];
		let i = splitBySno.length;
		// console.log(splitBySno);

		for (let j = i - 1; j >= 0; j -= 1) {
			let newNum = Number(splitBySno[j]) + 1;

			let sectionNoToCheck;
			if (j === 0) {
				sectionNoToCheck = newNum + "." + "1";
			} else {
				sectionNoToCheck = splitBySno.slice(0, j).join(".") + "." + newNum;
			}
			// console.log('Checking ', sectionNoToCheck);
			let nextSection;
			if (this.isPreview) {
				nextSection = this.getSectionByNo(sectionNoToCheck, this.programData.sections);
			} else {
				nextSection = this.getSectionByNo(sectionNoToCheck, this.userProgress.sections);
			}
			// console.log(nextSection);

			if (nextSection) {
				if (nextSection.type === "quiz" || nextSection.type === "download" || nextSection.type === "Quiz" || nextSection.type === "Download") {
					return nextSection.name;
				} else {
					return nextSection.metadata.topics[0].name;
				}
			}
		}

		return 'No Section Available';
	}

	getLearningMinutes(duration: any) {
		if (duration) {
			return this.sharedService.secondsToMinutes(duration);
		}

		return 0;
	}

	getDaysInRow(daysInRow: any) {
		return this.sharedService.getDaysInRow(daysInRow);
	}

	async setTargetDfsLabels(taskCompleted: boolean) {
		// console.log("Setting dfs label!");
		this.targetDfsLabels = [];
		this.createDfsObjects(this.userProgress.sections);

		for (let dfsObj of this.targetDfsLabels) {
			let isDfsComplete = this.checkIfDfsIsCompleted(dfsObj["dfs"], this.userProgress.sections);

			if (isDfsComplete) {
				dfsObj.isDfsCompleted = true;
				if (taskCompleted && dfsObj["dfs"] === this.selectedSection.dfs) {
					this.showGif("celebration");
					this.updateDoseCompletions();
					if (this.userProgress.progress < 100) {
						await this.programService.saveData(this.progressId, this.userProgress);
					}
				}
			} else {
				dfsObj.isDfsCompleted = false;

				let isThereIncompleteDfs = this.targetDfsLabels.some((obj: any) => obj.firstIncompleteDfs);
				if (!isThereIncompleteDfs) {
					dfsObj.firstIncompleteDfs = true;
				}
			}
		}
		this.appRef.tick();
		// console.log("after setting label!")
	}

	getTopicById(topicId: String) {
		for (let topic of this.selectedSection.metadata.topics) {
			if (topic.id === topicId) {
				return topic;
			}
		}
	}

	getLearningHrs() {
		if (this.userProgress.sections) {
			const seconds = this.sharedService.getTotalLearningHrs(this.userProgress.sections);
			return this.sharedService.secondsToMinutes(seconds);
		}

		return 0;
	}

	activeQuiz(sectionNo: any) {
		if (sectionNo == this.selectedSection?.sno) {
			// return 'selected_quiz';
			return '';
		}
	}

	activeVideo(topicId: any): any {
		if (topicId == this.selectedTopicId) {
			// return 'selected_video';
			return '';
		}
	}

	getNextTopic(topicId: string, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let j = 0; j < sections.length; j += 1) {
				let section = sections[j];

				if (section.type === 'video' || section.type === 'Video') {
					let topics = section.metadata.topics;

					for (let i = 0; i < topics.length; i += 1) {
						if (topics[i].id === topicId) {
							if ((i + 1 < topics.length) && topics[i + 1]) {
								// console.log('ret', topics[i]);
								return topics[i + 1];
							} else {
								if (j + 1 < sections.length) {
									let nextVideo: any = this.getNextVideoSection(sections, j + 1);
									// console.log('nv ', nextVideo);

									if (nextVideo?.metadata?.topics.length >= 1) {
										return nextVideo.metadata.topics[0];
									}

									return {};
								}

								return {};
							}
						}
					}
				} else if (section.type === 'menu' || section.type === 'Menu') {
					return this.getNextTopic(topicId, section.menu);
				}
			}
		}

		return {};
	}

	async moveToNextSection() {
		let nextSection = this.getNextSection();

		if (nextSection && Object.keys(nextSection).length >= 1) {
			if (nextSection.type === 'topic') {
				this.selectedTopicId = nextSection.section.id;
				const prevSelectedSection = this.selectedSection;
				this.selectedSection = this.getParentSection(this.selectedTopicId, this.userProgress.sections);
				// console.log(this.selectedSection);

				this.collapseByActiveSection();
				this.getParentSections(this.selectedSection.sno);
				// console.log('New video location', nextSection.section.videoLocation);
				this.updateVideoElement(nextSection.section.videoLocation);
				this.sectionDescription = nextSection.section.description;
				this.sectionName = nextSection.section.name;
				if (!this.isPreview) {
					await this.setupVideoListeners();
				}

				// if next section is within same unit, autoplay the video
				if (prevSelectedSection.sno === this.selectedSection.sno) {
					this.playVideo();
				}
			} else if (nextSection.type === 'quiz' || nextSection.type === 'Quiz') {
				this.clickedSection(nextSection.section);
			} else if (nextSection.type === 'download' || nextSection.type === 'Download') {
				this.clickedSection(nextSection.section);
			}
			if (!this.isPreview) {
				this.showGif('new-section');
			}
		} else if (!this.isPreview && this.userProgress.progress === 100) {
			this.snackbar.open("No section available!", "OK", {
				duration: 3000
			});
		}
	}

	getNextSection() {
		if (this.selectedSection.type === "video" || this.selectedSection.type === "Video") {
			let nextTopic;
			if (this.isPreview) {
				nextTopic = this.getSectionNextTopic(this.selectedTopicId, this.programData.sections);
			} else {
				nextTopic = this.getSectionNextTopic(this.selectedTopicId, this.userProgress.sections);
			}

			if (nextTopic && Object.keys(nextTopic).length >= 1) {
				return { section: nextTopic, type: 'topic' };
			}

			const splitBySno = this.selectedSection.sno?.split(".");
			let i = splitBySno.length;
			// console.log(splitBySno);
			let sectionCheck = false;

			for (let j = i - 1; j >= 0; j -= 1) {
				let newNum = Number(splitBySno[j]) + 1;

				let sectionNoToCheck;
				if (j === 0) {
					sectionNoToCheck = newNum + "." + "1";
				} else {
					sectionNoToCheck = splitBySno.slice(0, j).join(".") + "." + newNum;
				}
				// console.log(sectionNoToCheck);

				let nextSection;
				if (this.isPreview) {
					nextSection = this.getSectionByNo(sectionNoToCheck, this.programData.sections);
				} else {
					nextSection = this.getSectionByNo(sectionNoToCheck, this.userProgress.sections);
				}

				if ((!nextSection && !sectionCheck) || (nextSection && Object.keys(nextSection).length === 0 && !sectionCheck)) {
					sectionCheck = true;
					continue;
				}

				var prevSectionDfs = Number(nextSection.dfs) - 1;
				var isPrevDfsCompleted = false;

				if (this.isPreview) {
					isPrevDfsCompleted = true;
				} else {
					if (prevSectionDfs >= 1) {
						isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
					} else {
						isPrevDfsCompleted = true;
					}
				}

				if (!isPrevDfsCompleted) {
					this.showUnaccessibilitySnackbar();
					return {};
				}
				// console.log('ns', nextSection);

				if (nextSection.type === 'quiz' || nextSection.type === 'download' || nextSection.type === 'Quiz' || nextSection.type === 'Download') {
					return { section: nextSection, type: nextSection.type };
				}

				nextTopic = this.getFirstTopicOfSection(nextSection);
				if (nextTopic && Object.keys(nextTopic).length >= 1) {
					return { section: nextTopic, type: 'topic' };
				}

				return {};
			}
		}

		const splitBySno = this.selectedSection.sno?.split(".");
		let i = splitBySno.length;

		for (let j = i - 1; j >= 0; j -= 1) {
			let newNum = Number(splitBySno[j]) + 1;

			let sectionNoToCheck;
			if (j === 0) {
				sectionNoToCheck = newNum + "." + "1";
			} else {
				sectionNoToCheck = splitBySno.slice(0, j).join(".") + "." + newNum;
			}
			// console.log(sectionNoToCheck);
			let nextSection;
			if (this.isPreview) {
				nextSection = this.getSectionByNo(sectionNoToCheck, this.programData.sections);
			} else {
				nextSection = this.getSectionByNo(sectionNoToCheck, this.userProgress.sections);
			}
			// console.log(nextSection);

			if (nextSection && Object.keys(nextSection).length >= 1) {

				var prevSectionDfs = Number(nextSection.dfs) - 1;
				var isPrevDfsCompleted = false;

				if (this.isPreview)  {
					isPrevDfsCompleted = true;
				} else {
					if (prevSectionDfs >= 1) {
						// console.log(prevSectionDfs);
						isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
						// console.log(isPrevDfsCompleted);
					} else {
						isPrevDfsCompleted = true;
					}
				}

				if (!isPrevDfsCompleted) {
					this.showUnaccessibilitySnackbar();
					return {};
				}
				// console.log('ns', nextSection);

				if (nextSection.type === 'video' || nextSection.type === 'Video') {
					return { section: nextSection.metadata.topics[0], type: 'topic' };
				}
				return { section: nextSection, type: nextSection.type };
			}
		}

		return {};
	}

	checkIfDfsIsCompleted(i: number, sections: any) {
		let [dfsProgress, totalDfsProgress] = this.getProgressForDfs(i, sections);
		if (dfsProgress === totalDfsProgress) {
			return true;
		}

		return false;
	}

	getAncestorAccordionPanel(sectionNo: string) {
		return sectionNo?.split(".")[0];
	}

	createDfsObjects(sections: any) {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				// if (section.type !== 'download') {
				if (section.type !== 'menu') {
					let doesDfsObjectExist = this.targetDfsLabels.some((obj: any) => obj.dfs === section.dfs);

					if (!doesDfsObjectExist) {
						this.targetDfsLabels.push({
							"dfs": section.dfs,
							"isDfsCompleted": false
						});
					}
				} else {
					this.createDfsObjects(section.menu);
				}
				// }
			}
		}
	}

	getNextVideoSection(sections: any, index: number) {
		for (let i = index; i < sections.length; i += 1) {
			let section = sections[i];

			if (section.type === 'video' || section.type === 'Video') {
				return section;
			}
		}
	}

	collapseByActiveSection() {
		var ancestorAccordionPanelId = this.getAncestorAccordionPanel(this.selectedSection?.sno);
		this.accordionActiveIds = [ancestorAccordionPanelId];
		this.collapseItemsBySection(this.userProgress.sections);
	}

	tenSecondsBack() {
		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			let newVideoTime = videoElement.currentTime - 10;

			if (newVideoTime <= 0) {
				videoElement.currentTime = 0;
			} else {
				videoElement.currentTime = newVideoTime;
			}
		}
	}

	onVideoPause(event: any) {
		// console.log('this.videoPaused', this.videoPaused);
		this.videoPaused = true;
		// console.log('this.videoPaused', this.videoPaused);
	}

	showGif(gifType: string) {
		// console.log(gifType);
		this.showBlinkGif = false;
		if (gifType === 'screen-open') {
			this.showCelebrationGif = false;
			this.showNewSectionGif = false;
			this.showScreenOpenGif = true;

			setTimeout(() => {
				// console.log('change to blink');
				this.showScreenOpenGif = false;
				this.showBlinkGif = true;
			}, 5000);
		} else if (gifType === 'celebration') {
			this.showNewSectionGif = false;
			this.showScreenOpenGif = false;
			this.showCelebrationGif = true;

			setTimeout(() => {
				this.showCelebrationGif = false;
				this.showBlinkGif = true;
			}, 5000);
		} else if (gifType === 'new-section') {
			this.showCelebrationGif = false;
			this.showScreenOpenGif = false;
			this.showNewSectionGif = true;

			setTimeout(() => {
				this.showNewSectionGif = false;
				this.showBlinkGif = true;
			}, 5000);
		}
	}

	toggleMute() {
		this.isMuted = !this.isMuted;
		this.api.volume = this.isMuted ? 0 : 1;
	}

	// onPlayerReady(api: any) {
	// 	console.log('asdfghjk')
	// 	setTimeout(() => {
	// 		console.log('asdfghjk')
	// 		api.getDefaultMedia().subscriptions.pause.subscribe(() => {
	// 			this.videoPaused = true;
	// 			console.log('asdfghjk')
	// 		});
	// 		api.getDefaultMedia().subscriptions.play.subscribe(() => {
	// 			this.videoPaused = false;
	// 			console.log('asdfghjk')
	// 		});
	// 	});
	// }

	getQuizPercentage(sectionNo: any, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const quizScore = this.getQuizPercentage(sectionNo, section.menu);

					if (quizScore !== -1) {
						return quizScore;
					} else {
						continue;
					}
				} else if (section.sno === sectionNo) {
					return Math.floor((section.earnedPts * 100) / section.pts);
				}
			}
		}

		return -1;
	}

	getSectionPoster() {
		if (this.selectedSection?.metadata?.coverImg) {
			return this.selectedSection?.metadata?.coverImg;
		}

		return "";
	}

	getSectionNextTopic(topicId: string, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let j = 0; j < sections.length; j += 1) {
				let section = sections[j];

				if (section.type === 'video' || section.type === 'Video') {
					let topics = section.metadata.topics;

					for (let i = 0; i < topics.length; i += 1) {
						if (topics[i].id === topicId) {
							if ((i + 1 < topics.length) && topics[i + 1]) {
								// console.log('ret', topics[i]);
								return topics[i + 1];
							}

							return {};
						}
					}
				} else if (section.type === 'menu' || section.type === 'Menu') {
					const sectionNextTopic = this.getSectionNextTopic(topicId, section.menu);

					if (sectionNextTopic && Object.keys(sectionNextTopic).length >= 1) {
						return sectionNextTopic;
					} else {
						continue;
					}
				}
			}
		}

		return {};
	}

	getTopicProgress(topicId: any, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const progress = this.getTopicProgress(topicId, section.menu);

					if (progress !== -1) {
						return progress;
					} else {
						continue;
					}
				} else if (section.type === "video" || section.type === "Video") {
					for (let topic of section.metadata.topics) {
						if (topic.id === topicId) {
							const progress = Number(topic.progress);
							return Number.isFinite(progress) ? progress : 0;
						}
					}
				}
			}
		}

		return -1;
	}

	getFirstTopicOfSection(section: any) {
		return section.metadata.topics[0];
	}

	showUnaccessibilitySnackbar() {
		if (localStorage.getItem("alertShown") !== "true") {
			if (this.selectedSection.type === "quiz") {
				this.openCustomAlert("quiz");
			} else if (this.selectedSection.type === "download") {
				this.openCustomAlert("download");
			} else if (this.selectedSection.type === "video") {
				// console.log("1");
				this.openCustomAlert("video");
			}
			localStorage.setItem("alertShown", "true");
		}
	}

	clickedOutside(): void {
		this.showVol = false;
	}

	muteBtnClick(action: string) {
		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			if (action === 'mute') {
				videoElement.muted = true;
			} else if (action === 'unmute') {
				videoElement.muted = false;
				if (this.muteButtonClicks === 0) {
					videoElement.volume = this.videoVolume;
				}
			}

			this.muteButtonClicks += 1;
		}
	}

	isVideoMuted() {
		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			return videoElement.muted || videoElement.volume == 0;
		}
	}

	volumeSliderChange(event: any) {
		this.videoVolume = event.value;

		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			return videoElement.volume = this.videoVolume;
		}
	}

	async downloadDocument(sectionDfs: any, downloadLink: string, index: number) {
		if (this.isPreview) {
			window.open(downloadLink, "_blank");
		} else {
			if (this.userProgress.progress < 100) {
				var prevSectionDfs = Number(sectionDfs) - 1;
				var isPrevDfsCompleted = false;

				if (prevSectionDfs >= 1) {
					isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
				} else {
					isPrevDfsCompleted = true;
				}

				if (!isPrevDfsCompleted) {
					if (localStorage.getItem("alertShown") !== "true") {
						if (this.selectedSection.type === "quiz") {
							this.openCustomAlert("quiz");
						} else if (this.selectedSection.type === "download") {
							this.openCustomAlert("download");
						} else if (this.selectedSection.type === "video") {
							// console.log("1");
							this.openCustomAlert("video");
						}
						localStorage.setItem("alertShown", "true");
					}
					return;
				} else {
					window.open(downloadLink, "_blank");
					this.updateDownloadDocumentProgress(sectionDfs, this.userProgress.sections, index);
					await this.programService.saveDownloadProgress(this.progressId, this.userProgress);
					await this.setTargetDfsLabels(true);
				}
			} else {
				window.open(downloadLink, "_blank");
				await this.dashboardService.updateProgramLastAccess(this.progressId);
			}
		}
	}

	updateDownloadDocumentProgress(sectionDfs: any, sections: any, index: number) {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					this.updateDownloadDocumentProgress(sectionDfs, section.menu, index);
				} else if ((section.type === 'download' || section.type === 'Download') && section.dfs === sectionDfs) {
					for (let document of section.metadata.documents) {
						document.progress = 100;
					}

					let documentProgress = 0;
					for (var i = 0; i < section.metadata.documents.length; i += 1) {
						documentProgress += section.metadata.documents[i].progress;
					}

					section.progress = Math.ceil(documentProgress / i);
				}
			}
		}
	}

	resetQuizData() {
		this.quizData = [];

		for (let question of this.selectedSection.metadata.questions) {
			if (!question.type || question.type === "1" || question.type === "2") {
				this.quizData.push(-1);
			} else if (question.type === '3') {
				this.quizData.push([]);
			}
		}
	}

	isLastSection() {
		let nextSection = this.getNextSection();

		if (nextSection && Object.keys(nextSection).length >= 1) {
			// console.log('nextSection', nextSection)
			// console.log('Object.keys(nextSection)', Object.keys(nextSection))
			return false;
		}
		return true;
	}

	muteVideoInitially() {
		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			videoElement.muted = true;
			videoElement.volume = 0;
		} else {
			setTimeout(() => {
				this.muteVideoInitially();
			}, 500);
		}
	}

	showProgramMenu() {
		// console.log('close')
		this.showSideMenu = !this.showSideMenu
	}

	getTopicLearningDuration(topicId: string, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const duration = this.getTopicLearningDuration(topicId, section.menu);

					if (duration !== -1) {
						return duration;
					} else {
						continue;
					}
				} else if (section.type === "video" || section.type === "Video") {
					for (let topic of section.metadata.topics) {
						if (topic.id === topicId) {
							return topic.learningDuration;
						}
					}
				}
			}
		}

		return -1;
	}

	sortActiveProgramsByAccessOrder() {
		this.activePrograms.sort(function sortByAccessOrder(programA: any, programB: any) {
			if (programA.lastUpdatedAt > programB.lastUpdatedAt) {
				return -1;
			} else if (programA.lastUpdatedAt < programB.lastUpdatedAt) {
				return 1;
			}

			return 0;
		});
	}

	getFormattedCourseTime(courseTime: any) {
		return this.sharedService.getFormattedCourseTime(courseTime);
	}

	calculateHeight(): string {
		const objectElement: any = document.querySelector('.pdfembd');
		if (objectElement) {
			const contentHeight = objectElement?.offsetHeight;
			return `${contentHeight}px`;
		}
		return '100%';
	}

	displayVideoTimeLeft() {
		const videoElement: any = document.getElementById('masterVideo');
		// console.log(videoElement);

		if (videoElement) {
			let remSeconds = Math.floor(videoElement.duration) - Math.floor(videoElement.currentTime);
			let returnTime = "";

			let minutes = Math.floor(remSeconds / 60);
			if (minutes >= 10) {
				returnTime += `${minutes}`;
			} else {
				returnTime += `0${minutes}`;
			}

			returnTime += ":";

			let seconds = Math.floor(remSeconds % 60);
			if (seconds >= 10) {
				returnTime += `${seconds}`;
			} else {
				returnTime += `0${seconds}`;
			}

			// console.log(returnTime);
			if (isNaN(minutes) || isNaN(seconds)) {
				return "00:00";
			}
			return returnTime;
		} else {
			return "00:00";
		}
	}

	async preventScrubBarClick(event: MouseEvent) {
		const orgData = await this.programService.checkProgramExistenceAndProgressBarLock();
		const ProgressBarLock: any = orgData?.progressBarLock;
		// console.log('ProgressBarLock', ProgressBarLock)

		if (ProgressBarLock) {

			const videoElement: any = document.getElementById('masterVideo');
			// console.log('videoElement', videoElement)
			if (videoElement) {
				// console.log('setup video listener');
				const viewingDuration = this.getTopicLearningDuration(this.selectedTopicId, this.userProgress.sections);
				const scrubBarElement = document.getElementById('scrub-bar');
				scrubBarElement?.classList.remove("clickable");
				scrubBarElement?.classList.add("non-clickable");
				event.stopPropagation();
				event.preventDefault();

				if (viewingDuration >= 1) {
					const videoDuration = this.getTopicTotalDuration(this.selectedTopicId, this.userProgress.sections);
					const currentTime = videoElement.currentTime;

					if (isNaN(videoDuration) || isNaN(currentTime)) {
						scrubBarElement?.classList.remove("clickable");
						scrubBarElement?.classList.add("non-clickable");
						event.stopPropagation();
						event.preventDefault();

						setTimeout(async () => {
							await this.setupVideoListeners();
						}, 500);
						return;
					} else {
						if (videoDuration - viewingDuration <= 3) {
							scrubBarElement?.classList.remove("non-clickable");
							scrubBarElement?.classList.add("clickable");
						} else {
							if (videoDuration - viewingDuration >= 5) {
								videoElement.currentTime = viewingDuration;

								scrubBarElement?.classList.remove("clickable");
								scrubBarElement?.classList.add("non-clickable");
								event.stopPropagation();
								event.preventDefault();
							} else {
								scrubBarElement?.classList.remove("non-clickable");
								scrubBarElement?.classList.add("clickable");

							}
						}
					}
				} else {
					scrubBarElement?.classList.remove("clickable");
					scrubBarElement?.classList.add("non-clickable");
					event.stopPropagation();
					event.preventDefault();
				}

				videoElement.onplaying = async (event: any) => {
					// console.log('on play event');
					this.showGif("new-section");
					await this.videoPlayEvent(videoElement, this.selectedTopicId, this.selectedSection, this.userProgress);
				};
			} else {
				setTimeout(async () => {
					await this.setupVideoListeners();
				}, 500);
			}
		}

		if (!ProgressBarLock) {
			// console.log('ProgressBarLock', ProgressBarLock)
			const scrubBarElement = document.getElementById('scrub-bar');
			scrubBarElement?.classList.add("clickable");
			scrubBarElement?.classList.remove("non-clickable");
		}

	}

	ngOnDestroy() {
		if (this.snackbarSubscription) {
			this.snackbarSubscription.unsubscribe();
		}
		this.videolikesSubscription?.unsubscribe();
		this.videoCommentsSubscription?.unsubscribe();
		this.progressDetailsSubscription?.unsubscribe();
		window.removeEventListener('message', this.handleIspringScormMessage);
	}

	getProgressDetails() {
		this.progressDetailsSubscription = this.programService.getProgressDetails(this.programId, this.userId).subscribe(res => {
			this.userProgress = res;
		});
	}

	getTopicTotalDuration(topicId: string, sections: any): any {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					const duration = this.getTopicTotalDuration(topicId, section.menu);

					if (duration !== -1) {
						return duration;
					} else {
						continue;
					}
				} else if (section.type === "video" || section.type === "Video") {
					for (let topic of section.metadata.topics) {
						if (topic.id === topicId) {
							return topic.videoDuration;
						}
					}
				}
			}
		}

		return -1;
	}

	isQuizCompleted(sectionNo: number, sections: any): boolean {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					if (section.menu.length >= 1) {
						const isSectionComplete = this.isQuizCompleted(sectionNo, section.menu);

						if (isSectionComplete) {
							return true;
						} else {
							continue;
						}
					}
				} else if (section.type === 'quiz' && section.sno === sectionNo) {
					const numValidQuestions = this.getNumberOfValidQuestions(section);
					// console.log(numValidQuestions);
					const attemptedQuestions = this.getNumberOfAttemptedQuestions(section);
					// console.log(attemptedQuestions);
					if (attemptedQuestions >= numValidQuestions) {
						return true;
					}

					return false;
				}
			}
		}

		return false;
	}

	getNumberOfValidQuestions(section: any) {
		let numValidQuestions = 0;

		if (section.metadata?.questions?.length) {
			const questionsArray: any[] = section.metadata.questions;

			for (let question of questionsArray) {
				if (question.text) {
					numValidQuestions += 1;
				}
			}
		}

		return numValidQuestions;
	}

	getNumberOfAttemptedQuestions(section: any) {
		let numAttemptedQuestions = 0;

		if (section.metadata?.questions?.length) {
			const questionsArray: any[] = section.metadata.questions;

			for (let question of questionsArray) {
				if (question.attemptedAnswer) {
					numAttemptedQuestions += 1;
				}
			}
		}

		return numAttemptedQuestions;
	}

	updateDoseCompletions() {
		let dosesCompleted = this.userProgress.dosesCompleted;

		if (dosesCompleted && Object.keys(dosesCompleted).length >= 1 && dosesCompleted[this.currentMonthAndYear]) {
			if (dosesCompleted[this.currentMonthAndYear][this.currentDate]) {
				this.userProgress.dosesCompleted[this.currentMonthAndYear][this.currentDate] += 1;
			} else {
				this.userProgress.dosesCompleted[this.currentMonthAndYear][this.currentDate] = 1;
			}
		} else if (dosesCompleted && Object.keys(dosesCompleted).length >= 1 && !dosesCompleted[this.currentMonthAndYear]) {
			this.userProgress.dosesCompleted[this.currentMonthAndYear] = {};
			this.userProgress.dosesCompleted[this.currentMonthAndYear][this.currentDate] = 1;
		} else if (!dosesCompleted || Object.keys(dosesCompleted).length <= 0 || !dosesCompleted[this.currentMonthAndYear]) {
			this.userProgress.dosesCompleted = {};
			this.userProgress.dosesCompleted[this.currentMonthAndYear] = {};
			this.userProgress.dosesCompleted[this.currentMonthAndYear][this.currentDate] = 1;
		}
	}

	isUserAdmin() {
		const username = localStorage.getItem('username');
		return (username && (username === "igniteadmin1@example.com" || username === "igniteadmin2@example.com" || username === 'devadmin1@example.com' || username === 'devadmin2@example.com' || username === 'terry@terryhawkins.com')) ? true : false;
	}

	handleKeyDown(event: KeyboardEvent) {
		if (event.code === 'Space') {
		  event.preventDefault();
		  const video: HTMLVideoElement = this.videoElemRef?.nativeElement;
		  if (video.paused) {
			video.play();
		  } else {
			video.pause();
		  }
		}
	}

	openCustomAlert(type: string) {
		const alertDialog = this.dialogRef.open(CustomAlertComponent, {
			data: {
				type
			},
			panelClass: `${type}-alert-class`,
			backdropClass: 'custom-alert-backdrop-class',
			hasBackdrop: true
		});

		alertDialog.afterClosed().subscribe(() => {
			localStorage.removeItem("alertShown");
		});
	}

	toggleCommentBox() {
		this.isCommentBoxOpen = !this.isCommentBoxOpen;
		const video: HTMLVideoElement = this.videoElemRef?.nativeElement;
		if (this.isCommentBoxOpen && video.played) {
			video.pause();
		}
	}

	async likeVideoFn(action:string) {
		if (action === 'like') {
			const likeObject = {
				createdAt: new Date(),
				programId: this.programId,
				sectionId: this.selectedSection.sno,
				topicId: this.selectedTopicId,
				emotionType: 'like',
				userId: this.userId,
				userName: localStorage.getItem('firstName') || ""
			};

			await this.likesService.likeVideo(likeObject);
		} else if (action === 'unlike') {
			const idsObject = {
				programId: this.programId,
				sectionId: this.selectedSection.sno,
				topicId: this.selectedTopicId,
				userId: this.userId
			};

			await this.likesService.unlikeVideo(idsObject);
		}
	}

	async commentSubmit() {
		const videoElement: any = document.getElementById('masterVideo');
		const videoCurrentTime = videoElement.currentTime;

		const commentObject = {
			userId: this.userId,
			text: this.commentText,
			programId: this.programId,
			sectionId: this.selectedSection.sno,
			topicId: this.selectedTopicId,
			entityType : 'video',
			createdAt: new Date(),
			videoTime: videoCurrentTime.toString(),
			userName: localStorage.getItem('firstName') || ""
		};

		if (this.commentText !== "") {
			const res = await this.likesService.saveVideoComment(commentObject);
			if (res) {
				this.toggleCommentBox();
				this.commentText = "";
			}
		}
	}

	getVideoComments() {
		const idsObject = {
			programId: this.programId,
			sectionId: this.selectedSection.sno,
			topicId: this.selectedTopicId,
			entityType: 'video',
			userId: this.userId
		};

		this.videoCommentsSubscription = this.likesService.getVideoComments(idsObject)?.subscribe(data =>{
			// console.log('data', data)
			if(data && data.length > 0) {
				this.videoComments = data.map(comment => ({
					...comment,
					formattedTime: this.formatTime(comment['createdAt'])
				}));

				this.sortVideoComments();
			}
		})
	}

	sortVideoComments() {
		const videoElement: any = document.getElementById('masterVideo');

		if (videoElement) {
			const currentTime = videoElement.currentTime;

			this.videoComments.sort((a: any, b: any) => {
				if ((currentTime - Number(a.videoTime)) > (currentTime - Number(b.videoTime))) {
					return -1;
				} else {
					return 1;
				}
			});
		} else {
			setTimeout(() => {
				this.sortVideoComments();
			}, 500);
		}
	}

	formatTime(createdAt: { seconds: number, nanoseconds: number }): string {
		const now = Date.now();
		const commentTime = new Date(createdAt.seconds * 1000 + createdAt.nanoseconds / 1000000).getTime();
		const timeDiff = now - commentTime;

		const sec = 1000;
		const min = sec * 60;
		const hour = min * 60;
		const day = hour * 24;
		const month = day * 30;  // Approximating month as 30 days
		const year = day * 365;  // Approximating year as 365 days

		if (timeDiff < min) {
		  const seconds = Math.floor(timeDiff / sec);
		  return `${seconds > 1 ? seconds + " sec ago" : 'Just now'}`;
		} else if (timeDiff < hour) {
		  const minutes = Math.floor(timeDiff / min);
		  return `${minutes} min${minutes > 1 ? 's' : ''}`;
		} else if (timeDiff < day) {
		  const hours = Math.floor(timeDiff / hour);
		  const minutes = Math.floor((timeDiff % hour) / min);
		  return `${hours} hr${hours > 1 ? 's' : ''} ${minutes} min${minutes > 1 ? 's' : ''}`;
		} else if (timeDiff < month) {
		  const days = Math.floor(timeDiff / day);
		  return `${days} day${days > 1 ? 's' : ''}`;
		} else if (timeDiff < year) {
		  const months = Math.floor(timeDiff / month);
		  return `${months} month${months > 1 ? 's' : ''}`;
		} else {
		  const years = Math.floor(timeDiff / year);
		  return `${years} year${years > 1 ? 's' : ''}`;
		}
	}

	// async getVttFile() {
	// 	const getVttFileContents = this.fns.httpsCallable('transcript-getVttFileContents');
	// 	const getVttFileContentsObs = getVttFileContents({
	// 		programId: this.programId,
	// 		sectionIndex: this.selectedSection.sno,
	// 		topicIndex: this.selectedTopicId
	// 	});
	// 	const getVttFileContentsRes: any = await this.sharedService.getObservableRes(getVttFileContentsObs);

	// 	if (getVttFileContentsRes.res === "success") {
	// 		this.transcriptContent = getVttFileContentsRes.data;
	// 		console.log(this.transcriptContent);
	// 	} else {
	// 		console.log(getVttFileContentsRes.msg);
	// 	}
	// }

	toggleIsTranscript() {
		this.isTranscript = !this.isTranscript;
		if (this.isTranscript) {
			// this.fetchVttFile("https://firebasestorage.googleapis.com/v0/b/bwi-ignite-retail.appspot.com/o/sample-vtt.vtt?alt=media&token=99cb325d-031e-4001-933a-58d60b55e798");
			const currentTopic: any = this.getCurrentTopic();
			this.fetchVttFile(currentTopic.vttFile);
		}
	}

	getCurrentTopic() {
		// console.log(this.programData);
		for (let section of this.programData.sections) {
			// if (section.sno === this.selectedSection.sno) {
				for (let unit of section.menu) {
					if (unit.sno === this.selectedSection.sno && unit.metadata && unit.metadata.topics) {
						for (let topic of unit.metadata.topics) {
							if (topic.id === this.selectedTopicId) {
								return topic;
							}
						}
					}
				}
			// }
		}

		return {};
	}

	convertToTimeFormat(seconds: number): string {
		const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
		const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
		const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
		const millis = ((seconds % 1) * 1000).toFixed(0).padStart(3, '0');
		// console.log(`${hrs}:${mins}:${secs}.${millis}`)
		return `${hrs}:${mins}:${secs}.${millis}`;
	}

	highlightCurrentTimeText(currentTime: string) {
		const [currentHours, currentMinutes, currentSecondsMilli]:any = currentTime.split(':');
		const [currentSeconds, currentMilli] = currentSecondsMilli.split('.');

		this.processedVttContent.forEach(block => {
		  const blockStart = new Date();
		  blockStart.setHours(block.startTimeHours, block.startTimeMinutes, block.startTimeSeconds, block.startTimeMilli);

		  const blockEnd = new Date();
		  blockEnd.setHours(block.endTimeHours, block.endTimeMinutes, block.endTimeSeconds, block.endTimeMilli);

		  const currentVideoTime = new Date();
		  currentVideoTime.setHours(currentHours, currentMinutes, currentSeconds, currentMilli);

		  block.isHighlighted = currentVideoTime >= blockStart && currentVideoTime <= blockEnd;
		});
	}


	fetchVttFile(url: string) {
		if (url) {
			this.isVttFileUrl = true;
			this.http.get(url, { responseType: 'text' }).subscribe(
			  data => {
				this.vttContent = data.replace(/\r/g, '');
				this.processVttContent();
			  },
			  error => console.error('Could not load the .vtt file', error)
			);
		} else {
			// console.log('no vtt url', this.isVttFileUrl)
			this.isVttFileUrl = false;
		}
	}

	processVttContent() {
		const vttBlocks = this.vttContent.split("\n\n");
		this.processedVttContent = vttBlocks.map((item:any) => {
			const parts = item.split("\n");
			const time = parts[0];
			if (time) {
				const text = parts.slice(1).join(" ");
				const [startTime, endTime] = time.split(" --> ");
				const [startTimeHours, startTimeMinutes, startTimeSeconds] = startTime.split(":");
				const [endTimeHours, endTimeMinutes, endTimeSeconds] = endTime.split(":");

				return {
					text: text,
					time: time,
					startTimeHours: startTimeHours,
					startTimeMinutes: startTimeMinutes,
					startTimeSeconds: startTimeSeconds.split(".")[0],
					startTimeMilli: startTimeSeconds.split(".")[1],
					endTimeHours: endTimeHours,
					endTimeMinutes: endTimeMinutes,
					endTimeSeconds: endTimeSeconds.split(".")[0],
					endTimeMilli: endTimeSeconds.split(".")[1],
				};
			} else {
				return {
					text: "",
					time: "",
					startTimeHours: "",
					startTimeMinutes: "",
					startTimeSeconds: "".split(".")[0],
					startTimeMilli: "".split(".")[1],
					endTimeHours: "",
					endTimeMinutes: "",
					endTimeSeconds: "".split(".")[0],
					endTimeMilli: "".split(".")[1],
				};
			}
		});
	}

	updateHighlights() {
		const videoElement: any = document.getElementById('masterVideo');
		const videoCurrentTime = videoElement.currentTime;

		this.highlightCurrentTimeText(this.convertToTimeFormat(videoCurrentTime));
		this.scrollTranscript();
	}

	scrollTranscript() {
		const videoElement: any = document.getElementById('masterVideo');
		const currentVideoTime = videoElement.currentTime;
		const totalVideoTime = videoElement.duration;

		const currentTimePercentage = currentVideoTime/totalVideoTime*100;

		const trasncriptContentElement: HTMLVideoElement = this.transcriptContentRef?.nativeElement;

		const scrollHeight = trasncriptContentElement.scrollHeight;
		const clientHeight = trasncriptContentElement.clientHeight;

		trasncriptContentElement.scrollTop = ((scrollHeight-clientHeight)*currentTimePercentage / 100) - 350;
	}

	captureProgramModalCloseEvent(event:any) {
		if(event) this.programModalRef.close()
	}
}
